import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsc_list_reranking_ast_refactor');
	},
};
